<template>
  <table class="table table-borderless table-border table-align">
    <thead>
    <tr>
      <th>
        <BkpsCheckBox @input="$emit('changeCheckAllRow', $event)" :value="checkAllRow"/>
      </th>
      <th v-for="column in columns" :key="column.key">{{ column.label }}</th>
      <th>Marcadores</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="ticket in tickets" :key="ticket.id">
      <td>
        <BkpsCheckBox v-model="ticket.checked" @input="$emit('changeCheckRow', $event)"/>
      </td>
      <td v-for="column in columns" :key="column.key">
        <template v-if="column.key === 'barcode_digits' && ticket.barcode_digits">
          <button
              class="btn btn-outline btn-sm"
              @click.prevent="copyBarcode(ticket.barcode_digits)"
              v-tooltip.bottom="{content: tokenClick}"
          >
            <BarcodeIcon />
          </button>
        </template>
          <template v-else-if="column.key === 'entityStatusId'">
          {{ vehicleStatusLabel(ticket) }}
        </template>
        <template v-else-if="column.key === 'fleetCode'">
          {{ fleetCodeLabel(ticket) }}
        </template>
        <span
            v-else-if="column.key === 'observation'"
            class="observation-cell"
            :title="ticket.observation"
        >
          {{ ticket.observation }}
        </span>
        <template v-else>
          {{ resolveValue(ticket, column) }}
        </template>
      </td>
      <td>
        <div class="d-flex justify-content-between">
          <div class="d-inline align-self-center">
            <div
                v-for="labelId in ticket.labelIds.slice(0,6)"
                :key="labelId.id"
                class="color-badge"
                :style="{ backgroundColor: `#${getColorName(labelId)}`}"
                v-tooltip.top="getLabelName(labelId)"
            ></div>
          </div>
          <div
              v-if="ticket.labelIds.length > 6"
              class="d-inline align-self-center"
          >
            (+{{ ticket.labelIds.length - 6 }})
          </div>
          <label-popover
              v-if="$withPolicy('cm-frotas', 'manage_labels')"
              class="ml-2 d-inline align-self-center"
              :labels="labels"
              :labelIds="ticket.labelIds"
              @associateLabels="associateLabels(ticket, $event)"
              @deletedLabel="$emit('fetchTickets')"
              @changeLabels="$emit('changeLabels')"
          />
        </div>
      </td>

      <td>
        <Dropdown
            title-dropdown="Opções"
            class="col-md ml-2 btn-sm btn-primary"
            position="right"
        >
          <ul class="mb-1 mt-1">
            <template v-if="$canDownload('cm-frotas', 'download_boleto')">
              <li
                  v-if="hasBoletoDocument(ticket)"
                  class="dropdown-item"
                  title="Clique para baixar o boleto"
                  @click="downloadDocument(ticket.id, 'boleto')"
              >
                Baixar boleto
              </li>
              <li v-else class="dropdown-item" title="Nenhum boleto disponível no momento" style="cursor: not-allowed; color: #8A9EB5;">
                Baixar boleto
              </li>
            </template>
            <li
                v-if="$canDownload('cm-frotas', 'download_fici')"
                title="Formulário de indicação do condutor infrator"
                class="dropdown-item" @click="downloadDocument(ticket.id, 'fici')"
            >
              Baixar FICI
            </li>
            <li
                v-if="$canDownload('cm-frotas', 'download_demonstrativo')"
                class="dropdown-item" @click="downloadDocument(ticket.id, 'demonstrativo')"
            >
              Baixar Demonstrativo
            </li>
            <template v-if="$canDownload('cm-frotas', 'download_notification')">
              <li
                  v-if="hasNotificationDocument(ticket)"
                  class="dropdown-item"
                  title="Clique para baixar o arquivo de notificação"
                  @click="downloadDocument(ticket.id, 'notification')"
              >
                Baixar Notificação
              </li>
              <li v-else class="dropdown-item" title="Nenhuma notificação disponível no momento" style="cursor: not-allowed; color: #8A9EB5;">
                Baixar Notificação
              </li>
            </template>
            <li>
              <router-link class="dropdown-item" :to="`/cm-frotas/multas/${ticket.id}`">
                Detalhes
              </router-link>
            </li>
          </ul>
        </Dropdown>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import GetUser from '@/mixins/GetUser'
import GetAccount from '@/mixins/GetAccount.vue'
import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'

import LabelPopover from '@/components/label/LabelPopover.vue'
import GlobalLoading from '@/mixins/GlobalLoading'
import Dropdown from '@/components/shares/specialTag/Dropdown.vue'
import BarcodeIcon from '@/components/icons/BarcodeIcon.vue'
import { vehicleStatusRowLabel } from '@/utils/vehicleStatus'

export default {

  components: {BarcodeIcon, Dropdown, LabelPopover, BkpsCheckBox },
  mixins: [GetUser, GetAccount, GlobalLoading],
  name: 'Table',
  props: {
    checkAllRow: { required: true, type: Boolean },
    columns: { required: true, type: Array },
    labels: { required: true, type: Array },
    tickets: { required: true, type: Array },
    entityStatusNames: { type: Object, default: () => ({}) }
  },
  data: () => ({
    tokenClick: 'Clique para copiar'
  }),
  methods: {
    openLoad() {
      this.openGlobalLoad()
    },
    closeLoad() {
      this.closeGlobalLoad()
    },
    getLabelName(labelId) {
      const label = this.labels.find(label => label.id === labelId)
      return label ? label.name : ''
    },
    getColorName(labelId) {
      const label = this.labels.find(label => label.id === labelId)
      return label ? label.color : ''
    },
    associateLabels(ticket, labelIds) {
      this.axios.post(`maestro/tickets/${ticket.id}/set_label`, { label_ids: labelIds })
        .then(() => ticket.labelIds = labelIds)
    },
    hasBoletoDocument(ticket) {
      return ticket.lastBoleto
    },
    hasNotificationDocument(ticket) {
      return ticket.lastNotification
    },
    downloadDocument(ticketId, kind) {
      this.openLoad()
      this.axios.get('/maestro/tickets/latest_documents', { params: { q: { id: ticketId, kind } } })
        .then(response => this.$parse.downloadByLink(response.data))
        .catch(e => this.$notify.addError(e))
        .finally(() => this.closeLoad())
    },
    copyBarcode(barcode) {
      const input = document.createElement('input')
      input.value = barcode
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$notify.add('Código de barras copiado com sucesso!')
    },
    vehicleStatusLabel(ticket) {
      return vehicleStatusRowLabel(ticket, this.entityStatusNames)
    },
    fleetCodeLabel(ticket) {
      const vehicle = ticket.vehicles || ticket.vehicle || {}
      return vehicle.fleetCode || vehicle.fleet_code || '-'
    },
    resolveValue(ticket, column) {
      const callback = typeof column.method === 'function' ? column.method : null
      const dataKey = column.field || column.key
      const value = dataKey.includes('.') ? ticket.dig(...dataKey.split('.')) : ticket[dataKey]

      return callback ? callback(value) : value
    }
  },
}
</script>

<style scoped>
.observation-cell {
  display: inline-block;
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.color-badge {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 4px;
  border-radius: 3px;
}
</style>
